export default [
	{
		class: 'title',
		html: `
			<h2 class='scroller-headline'>Case study: St Louis</h2>

			<p>Let's take a look at St Louis, which has the highest gun murder rate of any large city in the country.</p>

			<div class='gia-continue-scrolling'><p>continue scrolling<br><span></span></p></div>
		`
	},
	// {
	//
	// 	html: `
	// 		<p>This is St Louis</p>
	//
	// 		<div class='gia-continue-scrolling'><p>continue scrolling<br><span></span></p></div>
	// 	`
	// },

	{

		html: `
			<p>If every 2015 gun homicide in St Louis were distributed randomly, it would look something like this. But if you live in St Louis, you know that’s wrong. </p>
		`
	},
	{

		html: `
			<p> This is what the pattern of gun homicides in the city actually looks like.</p>
		`
	},

	{

		html: `
			<p>Homicides are concentrated in areas of high poverty. </p>
		`
	},

	{

		html: `
			<p>And the lowest educational attainment.</p>
		`
	},

	{

		html: `
			<p>And the neighborhoods forged out of decades of racial segregation. </p>

		`
	}
];
